import { render, staticRenderFns } from "./online.vue?vue&type=template&id=45306cd9&scoped=true&"
import script from "./online.vue?vue&type=script&lang=js&"
export * from "./online.vue?vue&type=script&lang=js&"
import style0 from "./online.vue?vue&type=style&index=0&id=45306cd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45306cd9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45306cd9')) {
      api.createRecord('45306cd9', component.options)
    } else {
      api.reload('45306cd9', component.options)
    }
    module.hot.accept("./online.vue?vue&type=template&id=45306cd9&scoped=true&", function () {
      api.rerender('45306cd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/child/online.vue"
export default component.exports